export default __webpack_public_path__ + "f20819c16f786f4f02917c0b42cb4456.ply";